<template>
  <div class="row justify-content-center">
    <div class="col-md-10 col-lg-8 col-xl-9 col-xxl-8 col-xxxl-6">
      <div class="card mb-25 border-0 rounded-0 bg-white authentication-card">
        <div class="card-body letter-spacing">
          <h4 class="text-black fw-bold mb-0 text-center">Recuperar Contraseña</h4>

          <p class="mb-0 fs-md-15 fs-lg-16 text-paragraph text-center sub-text">
            Ingrese su dirección de correo electrónico a continuación y le enviaremos un enlace para restablecer la
            contraseña.
          </p>

          <div v-if="error" class="alert alert-danger mt-15 mb-0">{{ error }}</div>
          <div v-if="success" class="alert alert-success mt-15 mb-0">
            Enviado!! Si no lo ves, revisa tu carpeta de spam.
          </div>

          <form class="mt-15" @submit.prevent="handleSubmit">
            <div class="form-group mb-15 mb-sm-20">
              <label class="d-block text-black fw-semibold mb-10">Correo electrónico</label>
              <input v-model.trim="email" type="email" class="form-control shadow-none rounded-0 text-black"
                placeholder="e.g. adam127704@gmail.com" :disabled="isSubmitting" autocomplete="email" />
            </div>

            <button
              class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100"
              type="submit" :disabled="isSubmitting || !isValidEmail">
              {{ isSubmitting ? "Enviando..." : "Recuperar" }}
            </button>

            <div class="text-center mt-15 mt-sm-20 mt-md-25">
              <router-link to="/login"
                class="link-btn text-decoration-none text-primary fw-medium fs-md-15 fs-lg-16 position-relative">
                <i class="ph-bold ph-arrow-left"></i>
                Volver a Iniciar Sesión
              </router-link>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthenticationService from "@/api/Authentication/AuthenticationService";

export default {
  name: "ForgotPassword",
  data() {
    return {
      email: "",
      isSubmitting: false,
      error: "",
      success: false,
    };
  },
  computed: {
    isValidEmail() {
      // simple validation
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
    },
  },
  methods: {
    async handleSubmit() {
      this.error = "";
      this.success = false;

      if (!this.isValidEmail) {
        this.error = "Please enter a valid email address.";
        return;
      }

      this.isSubmitting = true;

      try {

        const resp = await AuthenticationService.ForgotPassword({ email: this.email });

        if (!resp.success) {
          // WebApi often returns plain text on BadRequest("...")
          const text = await resp.text();
          this.error = text || "Solicitud fallida.";
          return;
        }

        this.success = true;
      } catch (e) {
        this.error = "Network error. Please try again.";
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
